module.exports = __webpack_public_path__ + "./docs/img/icon-russian.b2cd9c16e231dde55abe482f51bf759c.svg";